module.exports = __webpack_public_path__ + "img/thumbnail_SiberianTiger_j_albino.f3327c23.png";